// Art registry: filled by the procedural art builders in BootScene, read by
// renderers (MechView, item cards, preview). Texture keys for shared textures
// live in ./keys.ts.

import type { EquipVisual, MechArt, MechId, WeaponArt, WeaponId } from '../core/types';

export interface ArtRegistry {
  mechs: Partial<Record<MechId, MechArt>>;
  weapons: Partial<Record<WeaponId, WeaponArt>>;
  /** EquipId → rigid modules attached to the mech. */
  visuals: Record<string, EquipVisual>;
  /** Exported metadata (attachment points, timing) for the asset pipeline, by mech. */
  sheetsMeta: Partial<Record<MechId, unknown>>;
}

export const art: ArtRegistry = {
  mechs: {},
  weapons: {},
  visuals: {},
  sheetsMeta: {},
};
